module.exports = __webpack_public_path__ + "img/cloud-r.bbedf779.png";